"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ControlledInputField = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FormLabel = _interopRequireDefault(require("../FormLabel"));

var _HelpText = _interopRequireDefault(require("../HelpText"));

var _ValidationMessage = _interopRequireDefault(require("../ValidationMessage"));

var _ControlledInput = _interopRequireDefault(require("../ControlledInput/ControlledInput"));

var styles = {
  "ControlledInputField": "ControlledInputField__ControlledInputField___2uIG9",
  "ControlledInputField--disabled": "ControlledInputField__ControlledInputField--disabled___HDWt6",
  "ControlledInputField__input": "ControlledInputField__ControlledInputField__input___3OMYB",
  "ControlledInputField__label": "ControlledInputField__ControlledInputField__label___a9J52",
  "ControlledInputField__label--light": "ControlledInputField__ControlledInputField__label--light___2G2AZ"
};
var defaultProps = {
  testId: 'cf-ui-controlled-input-field',
  labelIsLight: false,
  checked: false,
  inputType: 'checkbox'
};

var ControlledInputField = function ControlledInputField(props) {
  var id = props.id,
      labelIsLight = props.labelIsLight,
      testId = props.testId,
      required = props.required,
      helpText = props.helpText,
      disabled = props.disabled,
      labelText = props.labelText,
      helpTextProps = props.helpTextProps,
      formLabelProps = props.formLabelProps,
      className = props.className,
      checked = props.checked,
      value = props.value,
      validationMessage = props.validationMessage,
      onChange = props.onChange,
      children = props.children,
      inputType = props.inputType,
      inputProps = props.inputProps,
      name = props.name,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["id", "labelIsLight", "testId", "required", "helpText", "disabled", "labelText", "helpTextProps", "formLabelProps", "className", "checked", "value", "validationMessage", "onChange", "children", "inputType", "inputProps", "name"]);
  var classNames = (0, _classnames["default"])(styles['ControlledInputField'], className, (0, _defineProperty2["default"])({}, styles['ControlledInputField--disabled'], disabled));
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    "data-test-id": testId,
    className: classNames
  }, otherProps), /*#__PURE__*/_react["default"].createElement(_ControlledInput["default"], (0, _extends2["default"])({
    id: id,
    labelText: labelText,
    type: inputType,
    name: name,
    required: required,
    checked: checked,
    disabled: disabled,
    value: value,
    onChange: onChange,
    className: styles.ControlledInputField__input
  }, inputProps)), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles['Checkbox__label-wrapper']
  }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], (0, _extends2["default"])({
    className: (0, _classnames["default"])(styles.ControlledInputField__label, (0, _defineProperty2["default"])({}, styles['ControlledInputField__label--light'], labelIsLight)),
    required: required,
    htmlFor: id
  }, formLabelProps), labelText), helpText && /*#__PURE__*/_react["default"].createElement(_HelpText["default"], (0, _extends2["default"])({
    className: styles['ControlledInputField__help-text']
  }, helpTextProps), helpText), validationMessage && /*#__PURE__*/_react["default"].createElement(_ValidationMessage["default"], {
    className: styles['ControlledInputField__validation-message']
  }, validationMessage)));
};

exports.ControlledInputField = ControlledInputField;
ControlledInputField.defaultProps = defaultProps;
var _default = ControlledInputField;
exports["default"] = _default;